import React from 'react';
// import logo from './d3.png';
export default [{
  name: 'impact',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        Impact Analysis
      </div>
      <div className='portfolio-item__desc'>
        An acyclic graph visualization tool for impact analysis
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-js"></i>
        {/*<img className="customIcon" src="https://user-images.githubusercontent.com/16076593/47471585-6c990980-d867-11e8-9947-cbd55c2981d5.png"></img>*/}
        <img className="customIcon" src='/images/d3.png'></img>
      </div>
      <div className='portfolio-item__links'>
          <a target="_blank" rel="noopener noreferrer" href="https://arzon94.github.io/impact-build/">Demo</a>
          <a target="_blank" rel="noopener noreferrer" href="https://github.com/arzon94/impact-final">Github</a>
      </div>
    </div>
  )
},{
  name: 'spaces',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        Spaces
      </div>
      <div className='portfolio-item__desc'>
        A marketplace for tenants and properties
      </div>
      <div className='portfolio-item__icon'>
          <span>Flutter</span>
      </div>
      <div className='portfolio-item__links'>
        {/* <a target="_blank" rel="noopener noreferrer" href="https://www.npmjs.com/package/typy">NPM</a> */}
        <a target="_blank" rel="noopener noreferrer" href="https://forms.gle/53UWLm9U2QikoMGA9">Request to Join Alpha</a>
      </div>
    </div>
  )
},{
  name: 'deckbuilder',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        Deckbuilder
      </div>
      <div className='portfolio-item__desc'>
        <p>Magic the Gathering deck builder built with <a href="https://github.com/blakemorgan"><strong>Blake</strong></a></p>
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-vuejs"></i>
      </div>
      <div className='portfolio-item__links'>
        {/* <a target="_blank" rel="noopener noreferrer" href="https://www.npmjs.com/package/typy">NPM</a> */}
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/blakemorgan/deckbuilder">Github</a>
      </div>
    </div>
  )
}, {
  name: 'facer',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        Facer
      </div>
      <div className='portfolio-item__desc'>
        React-Native mobile app with neural network for identifying skin color
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-js"></i>
        <i className="fab fa-react"></i>
      </div>
      <div className='portfolio-item__links'>
        {/* <a target="_blank" rel="noopener noreferrer" href="https://www.npmjs.com/package/typy">NPM</a> */}
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/arzon94/facer">Github</a>
      </div>
    </div>
  )
}, {
  name: 'Dollarprobs',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        Dollarprobs
      </div>
      <div className='portfolio-item__desc'>
        Classifieds for odd jobs web app
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-laravel"></i>
        <i className="fab fa-vuejs"></i>
      </div>
      <div className='portfolio-item__links'>
        <a target="_blank" rel="noopener noreferrer" href="https://dev.to/flexdinesh/react-redux-boilerplate-with-best-practices--2pp5">Github</a>
        <a target="_blank" rel="noopener noreferrer" href="http://dollarprobs.herokuapp.com/instantsearch">Site</a>
      </div>
    </div>
  )
}, {
  name: 'byu-map',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        BYU Campus Map
      </div>
      <div className='portfolio-item__desc'>
         Brigham Young University's campus map web application
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-js"></i>
        <i className="fab fa-aws"></i>
      </div>
      <div className='portfolio-item__links'>
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/byuweb/byu-arcmap">Github</a>
        <a target="_blank" rel="noopener noreferrer" href="https://map.byu.edu/">More</a>
      </div>
    </div>
  )
}, {
  name: 'tableau-reports',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        Tableau Analytics Dashboard
      </div>
      <div className='portfolio-item__desc'>
        Reach and engagement of social media accounts, email campaigns, and news stories
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-js"></i>
      </div>
      <div className='portfolio-item__links'>
        <a target="_blank" rel="noopener noreferrer" href="https://public.tableau.com/profile/andrew.perkins#!/vizhome/CommunicationsandSocialMediaMetrics/JanuaryStory">More</a>
      </div>
    </div>
  )
}, {
  name: 'goldenspikes',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        Goldenspikes
      </div>
      <div className='portfolio-item__desc'>
       Uploads user submissions and dynamically creates spreadsheets of data.
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-python"></i>
        <i className="fab fa-aws"></i>
      </div>
      <div className='portfolio-item__links'>
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/arzon94/goldenspikes">Github</a>
        <a target="_blank" rel="noopener noreferrer" href="https://goldenspikes.herokuapp.com/submissions">More</a>
      </div>
    </div>
  )
}, {
  name: 'dev-landing-page',
  render: (
    <div className='portfolio-item'>
      <div className='portfolio-item__title'>
        React Portfolio Page
      </div>
      <div className='portfolio-item__desc'>
        Portfolio page with dynamic theming
      </div>
      <div className='portfolio-item__icon'>
        <i className="fab fa-react"></i>
        <i className="fab fa-js"></i>
      </div>
      <div className='portfolio-item__links'>
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/arzon94/mysitedev">Github</a>
      </div>
    </div>
  )
}]



// WEBPACK FOOTER //
// ./src/pages/PortfolioPage/portfolio-items.js